import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-table-zh",
  "use": "icon-table-zh-usage",
  "viewBox": "0 0 20 16",
  "content": "<symbol viewBox=\"0 0 20 16\" fill=\"\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-table-zh\">\r\n<path id=\"icon-table-zh_Vector\" d=\"M0 2H3V0H0V2ZM6 0V2H20V0H6ZM0 9H3V7H0V9ZM6 9H20V7H6V9ZM0 16H3V14H0V16ZM6 16H20V14H6V16Z\" fill=\"\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol